import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { AppService } from '../../services/app.service';
import { AuthService } from '../../services/auth.service';
import { MessageService } from '../../services/message.service';

const actions = {
    done: 'done',
    // init token authentication
    token: 'token',
    // init CRM token authentication
    crmToken: 'crmtoken',
    // init ADFS authentication
    adfs: 'adfs',
    // an error during authentication
    error: 'error',
    // successfull login but user has no rights
    noRights: 'no-rights',
    // when session id acquired
    success: 'success'
};

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
    constructor(
        private app: AppService,
        private auth: AuthService,
        private messages: MessageService,
        private route: ActivatedRoute
    ) { }

    action: string;
    accessDenied: boolean;
    noRightsWarning: string;

    ngOnInit() {
        this.accessDenied = this.route.snapshot.queryParams['accessDenied'] == 'true';

        this.route.params.subscribe(() => {
            this.init();
        });
    }

    logout() {
        this.app.showLoading();
        this.auth.logout();
    }

    private checkAuth(redirectUrl?: string) {
        const proceed = () => {
            if (redirectUrl) {
                this.app.navigateByUrl(decodeURIComponent(redirectUrl));
            } else {
                this.app.navigateToStart();
            }
        };

        if (this.auth.isAuthenticated) {
            if (!this.app.currentUser.rights.length) {
                this.app.navigateByUrl(`/login/${actions.noRights}`);
            } else {
                proceed();
            }
        } else {
            this.auth.authenticate().then(() => {
                proceed();
            });
        }
    }

    private redirectToError() {
        this.app.navigateByUrl(`/login/${actions.error}`);
    }

    private init() {
        const params = this.route.snapshot.params;
        const query = this.route.snapshot.queryParams;

        const redirectTo = query['redirecturl'];

        this.action = params['type'];

        const done = () => {
            this.action = actions.done;
            this.checkAuth(redirectTo);
        };

        if (!this.action || this.action == actions.done) {
            done();
        } else {
            if (this.action == actions.success) {
                done();
            } else if (this.action == actions.noRights) {
                this.app.addLoading(this.messages.getText('NO_RIGHTS')).subscribe(data => {
                    this.action = actions.done;
                    this.noRightsWarning = data[0]?.Text;
                });
            } else {
                if (!this.auth.isAuthenticated || this.action === actions.token || this.action === actions.crmToken) {
                    switch (this.action) {
                        case actions.token:
                            if (query['user'] && query['time'] && query['hash'] && query['area']) {
                                this.auth.loginByToken({
                                    user: query['user'],
                                    time: decodeURIComponent(query['time']),
                                    name: query['name'] || query['user'],
                                    hash: query['hash'],
                                    area: query['area'],
                                    lang: query['lang'] || this.app.currentLanguage
                                }).then(response => {
                                    if (response) {
                                        this.checkAuth(query.redirecturl || response.startUrl);
                                    } else {
                                        this.redirectToError();
                                    }
                                }, () => {
                                    this.redirectToError();
                                });
                            } else {
                                this.redirectToError();
                            }

                            break;

                        case actions.crmToken:
                            if (query['CustId'] && query['CustIdType'] && query['AdLogin'] && query['Token'] && query['Time']) {
                                this.auth.loginByCrmToken({
                                    custId: query['CustId'],
                                    custIdType: query['CustIdType'],
                                    adLogin: query['AdLogin'],
                                    time: decodeURIComponent(query['Time']),
                                    token: query['Token'],
                                    lang: query['lang'] || this.app.currentLanguage
                                }).then(response => {
                                    if (response) {
                                        this.checkAuth(query.redirecturl || response.startUrl);
                                    } else {
                                        this.redirectToError();
                                    }
                                }, () => {
                                    this.redirectToError();
                                });
                            } else {
                                this.redirectToError();
                            }

                            break;
                            
                        case actions.adfs:
                            this.auth.login(redirectTo);
                            break;

                        case actions.error:
                            break;
                    }
                } else {
                    done();
                }
            }
        }
    }
}
